import { ApiResponse } from 'apisauce';

import { generateApiClient } from '../api';
import { getGeneralApiProblem } from '../api/api-problem';
import { Manufacturer } from '../../types/manufacturer';

const api = generateApiClient();

export const getManufacturersApi = async (query?: any): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.get(`ProductManufacturers${query}`);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;

    return { kind: 'ok', data: data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const createManufacturersApi = async (manufacturer: Manufacturer): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.post(`ProductManufacturers`, manufacturer);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const updateManufacturersApi = async (manufacturerId: number, manufacturer: Manufacturer): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.put(`ProductManufacturers/${manufacturerId}`, manufacturer);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;
    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};
